import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "sidebar-wrapper scrollbar" }
const _hoisted_2 = { class: "sideplan-list-wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "no-results"
}
const _hoisted_5 = {
  key: 1,
  class: "no-results"
}

import { inject, ref, toRefs, watch } from 'vue';
import type { Lot, LotCountNeighborhood } from './../types';
import { isMobile, isTablet } from 'mobile-device-detect';
import { ModalType, Status } from '@/constant';
import SideBarPlanListItem from './SideBarPlanListItem.vue';
import lodash from 'lodash';

interface Props {
  selectedJobNum: string;
  qmiAndHomeplans: any[];
  selectedHomePlanIds: string[];
  selectedLotId: string;
  selectedHomePlanId: string;
  selectedLotStatus: string;
  availableLots: number;
  isKioskMode: boolean;
  neighborhoodId: string;
  listPlanId: string[];
  listHomeType: string[];
  selectedNeighborhoodIds: string[];
  initialHomePlanCount: number;
  lotsCount: LotCountNeighborhood[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBarPlanList',
  props: {
    selectedJobNum: {},
    qmiAndHomeplans: {},
    selectedHomePlanIds: {},
    selectedLotId: {},
    selectedHomePlanId: {},
    selectedLotStatus: {},
    availableLots: {},
    isKioskMode: { type: Boolean },
    neighborhoodId: {},
    listPlanId: {},
    listHomeType: {},
    selectedNeighborhoodIds: {},
    initialHomePlanCount: {},
    lotsCount: {}
  },
  emits: [
  'setHomePlanId',
  'cleanHomeId',
  'toggleShowFilters',
  'openModal',
  'closeModal',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const {
  selectedJobNum,
  qmiAndHomeplans,
  selectedHomePlanIds,
  selectedLotId,
  selectedHomePlanId,
  selectedLotStatus,
  availableLots,
  isKioskMode,
  neighborhoodId,
  listHomeType,
  selectedNeighborhoodIds,
  initialHomePlanCount,
  lotsCount,
} = toRefs(props);

const emit = __emit;

// injector
const isSalesOrLandView = inject('setSelectionDropdown', ref(false));

const hasMobile = !!(isMobile && !isTablet);

let planClicks = {};
const previousSelectedPlan = ref('');
const availableStatus = Status;
const plansToList = ref<any[]>([]);

const generateKey = (homePlan: any, index: number) =>
  `${homePlan.plan_code || 'no-plan-code'}-${
    homePlan.plan_id || 'no-plan-id'
  }-${homePlan.future_id || 'no-future-id'}-${index}`;

const QmiplanClickAction = (homePlan: any) => {
  if (hasMobile) {
    emit('toggleShowFilters');
  }
  homePlan.price >= 0
    ? planQmiClickAction(homePlan.job_number)
    : planClickAction(homePlan);
};

const planClickAction = (homePlan: any) => {
  const planId = homePlan.plan_id;
  if (previousSelectedPlan.value !== planId) {
    delete planClicks[planId];
  }
  previousSelectedPlan.value = planId;

  if (!planClicks[planId]) {
    planClicks[planId] = 0;
  }
  planClicks[planId]++;

  if (planClicks[planId] % 2) {
    emit('setHomePlanId', { planId, jobNum: '' });
    if (isSalesOrLandView.value)
      emit('openModal', { type: ModalType.PLAN_DETAILS, plan: homePlan });
  } else {
    emit('cleanHomeId');
  }
};

const planQmiClickAction = (jobNum: string) => {
  if (previousSelectedPlan.value !== jobNum) {
    delete planClicks[jobNum];
  }
  previousSelectedPlan.value = jobNum;

  if (!planClicks[jobNum]) {
    planClicks[jobNum] = 0;
  }
  planClicks[jobNum]++;

  if (planClicks[jobNum] % 2) emit('setHomePlanId', { planId: '', jobNum });
  else emit('cleanHomeId');
  emit('closeModal');
};

const checkSelected = (homePlan: any) => {
  const isNotSelectedFromSidebar =
    !selectedHomePlanId.value && !selectedJobNum.value;
  return isNotSelectedFromSidebar
    ? false
    : (selectedHomePlanId.value === homePlan.plan_id &&
        selectedJobNum.value.length <= 0) ||
        (lodash.includes(selectedHomePlanIds, homePlan.plan_id) &&
          !!selectedLotId.value &&
          selectedLotStatus.value === availableStatus.QUICK_MOVE_IN) ||
        selectedJobNum.value === homePlan.job_number;
};

watch(selectedLotId, (newVal) => {
  if (newVal) {
    planClicks = {};
  }
});

const updatePlans = () => {
  if (!isSalesOrLandView.value) {
    plansToList.value = qmiAndHomeplans.value;
    return;
  }
  const hasSelectedPlans = selectedHomePlanIds.value.length > 0;

  plansToList.value = hasSelectedPlans
    ? qmiAndHomeplans.value.filter(
        (plan) =>
          selectedHomePlanIds.value.includes(plan.plan_id) ||
          selectedLotId.value.includes(plan.job_number)
      )
    : qmiAndHomeplans.value;
};
watch([selectedHomePlanIds, qmiAndHomeplans], updatePlans, {
  immediate: true,
});

const voidHomePlanId = () => {
  previousSelectedPlan.value = '';
  emit('cleanHomeId');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plansToList.value, (homePlan, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: generateKey(homePlan, index),
          class: _normalizeClass([
          'sideplan-list emb-card',
          {
            'is-selected': checkSelected(homePlan),
          },
        ]),
          onClick: ($event: any) => (QmiplanClickAction(homePlan))
        }, [
          _createVNode(SideBarPlanListItem, {
            homePlan: homePlan,
            qmiAndHomeplans: plansToList.value,
            selectedLotId: _unref(selectedLotId),
            isKioskMode: _unref(isKioskMode),
            neighborhoodId: _unref(neighborhoodId),
            selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
            lotsCount: _unref(lotsCount),
            onSetHomePlanId: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('setHomePlanId', $event))),
            onCleanHomeId: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cleanHomeId'))),
            onToggleshowFilters: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleShowFilters'))),
            onVoidHomePlanId: _cache[3] || (_cache[3] = ($event: any) => (voidHomePlanId()))
          }, null, 8, ["homePlan", "qmiAndHomeplans", "selectedLotId", "isKioskMode", "neighborhoodId", "selectedNeighborhoodIds", "lotsCount"])
        ], 10, _hoisted_3))
      }), 128)),
      (!_unref(qmiAndHomeplans).length && _unref(initialHomePlanCount))
        ? (_openBlock(), _createElementBlock("h4", _hoisted_4, " No Results Available "))
        : _createCommentVNode("", true),
      (!_unref(initialHomePlanCount))
        ? (_openBlock(), _createElementBlock("h4", _hoisted_5, " Home plans coming soon "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})